import { Role } from "data/User";

export const USER_ROLES_STINGS = {
    ADMIN: 'Admin',
    BRAND_ADMIN: 'Brand Admin',
    SUPER_ADMIN: 'Super Admin',
    VENDOR: 'Vendor',
    VENDOR_ADMIN: 'Vendor Admin',
    MARKETING: 'Marketing',
    SALES: 'Sales',
    FINANCE: 'Finance',
    FULFILMENT: 'Fulfilment'
}

export const FILTERED_USER_ROLES = [
    Role.Vendor,
    Role.Admin,
    Role.SuperAdmin
]

export const USER_ROLE_MAPPER: any = {
    [Role.Admin]: USER_ROLES_STINGS.ADMIN,
    [Role.BrandAdmin]: USER_ROLES_STINGS.BRAND_ADMIN,
    [Role.SuperAdmin]: USER_ROLES_STINGS.SUPER_ADMIN,
    [Role.Vendor]: USER_ROLES_STINGS.VENDOR,
    [Role.VendorAdmin]: USER_ROLES_STINGS.VENDOR_ADMIN,
    [Role.Marketing]: USER_ROLES_STINGS.MARKETING,
    [Role.Sales]: USER_ROLES_STINGS.SALES,
    [Role.Finance]: USER_ROLES_STINGS.FINANCE,
    [Role.Fulfilment]: USER_ROLES_STINGS.FULFILMENT
}

export const BUSINESS_UNIT_USER_ROLES = [
    { value: USER_ROLES_STINGS.BRAND_ADMIN, id: Role.BrandAdmin },
    { value: USER_ROLES_STINGS.MARKETING, id: Role.Marketing },
    { value: USER_ROLES_STINGS.SALES, id: Role.Sales },
    { value: USER_ROLES_STINGS.FINANCE, id: Role.Finance },
    { value: USER_ROLES_STINGS.FULFILMENT, id: Role.Fulfilment },
]

export const VENDOR_ADMIN_ROLE = [{ value: USER_ROLES_STINGS.VENDOR_ADMIN, id: Role.VendorAdmin }];
export const OFMP_ADMIN = [{ value: USER_ROLES_STINGS.ADMIN, id: Role.Admin }];

export const ADMIN_ROLES = [Role.Admin.toString(), Role.SuperAdmin.toString()];
export const VENDOR_ROLES = [Role.Vendor.toString(), Role.VendorAdmin.toString()];